import { laptopRatio, mobileRatio, theme } from '../../../../theme';
import { getResponsiveSize } from '../../../../utils';

export const clientStepStyles = {
  clientSelect: {
    '& .checkbox-card-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      gap: getResponsiveSize(44), // 44px
      '& .MuiPaper-root': {
        maxWidth: getResponsiveSize(440), // 440px
      },
    },
    '& .add-client-input': {
      '& .select-existing-client': {
        transform: `translateX(${getResponsiveSize(12)})`,
        color: theme.palette.myPrimary.lightBlue70,
        borderRadius: getResponsiveSize(10),
        width: getResponsiveSize(40),
        height: getResponsiveSize(40),
      },
    },
    '& .use-prev-config': {
      border: `1px solid ${theme.palette.myPrimary.lightBlue100}`,
      height: getResponsiveSize(53),
      width: getResponsiveSize(53),
      backgroundImage: `linear-gradient(to left, transparent 50%, ${theme.palette.myPrimary.lightBlue40} 50%)`,
      color: theme.palette.myPrimary.lightBlue100,
      backgroundSize: '200%',
      backgroundPosition: ' right bottom',
      borderRadius: theme.palette.propVars.borderRadius,
      transition:
        '.45s background cubic-bezier(0.4, 0, 0.2, 1), .4s box-shadow cubic-bezier(0.4, 0, 0.2, 1)',
      '&:hover': {
        backgroundPosition: 'left bottom',
      },
      '&.active.Mui-disabled': {
        borderColor: theme.palette.myPrimary.green,
        color: theme.palette.myPrimary.green,
        backgroundImage: `linear-gradient(to left, ${theme.palette.dashBoar.mintGreenRGBA} 50%, transparent  50%)`,
        backgroundPosition: ' right bottom',
      },
    },
    [theme.breakpoints.media.desktop]: {
      '& .use-prev-config': {
        '& .MuiSvgIcon-root': {
          fontSize: getResponsiveSize(22),
        },
      },
    },
    [theme.breakpoints.media.laptop]: {
      '& .use-prev-config': {
        height: getResponsiveSize(49, laptopRatio),
        width: getResponsiveSize(49, laptopRatio),
        '& .MuiSvgIcon-root': {
          fontSize: getResponsiveSize(20, laptopRatio),
        },
      },
    },
    // Tablet screen
    [theme.breakpoints.media.tablet]: {
      '& .checkbox-card-wrapper': {
        flexDirection: 'column',
      },
    },
    [theme.breakpoints.media.tableResponsive]: {
      '& .use-prev-config': {
        height: getResponsiveSize(41.5, mobileRatio),
        width: getResponsiveSize(41.5, mobileRatio),
        borderRadius: getResponsiveSize(8, mobileRatio),
        '& .MuiSvgIcon-root': {
          fontSize: getResponsiveSize(18, mobileRatio),
        },
      },
    },
  },
};
